
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/press",
      function () {
        return require("private-next-pages/[locale]/press.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/press"])
      });
    }
  